import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { toolbarButtonSx, toolbarIconSize } from "./toolbarStyles";

/** Red-family text readable on the hover wash; the brand has no red of its own. */
const DANGER_TEXT = "#A32D2D";
const DANGER_WASH = "#FBEFEF";

interface ClearChatButtonProps {
  onClearChat: () => void;
  compact?: boolean;
  disabled?: boolean;
  /** Overrides the tooltip, e.g. to say why the button is disabled. */
  tooltip?: string;
}

/**
 * Clear chat as a toolbar segment. It rests in the same quiet color as every other action and
 * only turns red on hover, so a destructive action is reachable in one click without shouting.
 * The confirmation dialog that `onClearChat` opens is the safety net.
 */
function ClearChatButton({
  onClearChat,
  compact = false,
  disabled = false,
  tooltip = "Clear chat",
}: ClearChatButtonProps) {
  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          size="small"
          aria-label="Clear chat"
          disabled={disabled}
          onClick={onClearChat}
          sx={{
            ...(toolbarButtonSx(compact) as object),
            "&:hover": { backgroundColor: DANGER_WASH, color: DANGER_TEXT },
          }}
        >
          <DeleteOutlineIcon sx={{ fontSize: toolbarIconSize(compact) }} />
        </IconButton>
      </span>
    </Tooltip>
  );
}

export default ClearChatButton;
